import { CreditCardBorrower, getCreditCardDetailsById } from '@nemuru-eng/js-api-client';
import { useMemo } from 'react';

import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';

interface UseCreditCardDetailsProps {
  creditCardId: string;
}

export const useCreditCardDetails = ({ creditCardId }: UseCreditCardDetailsProps) => {
  const {
    state: { applicationParticipant },
  } = usePageContext();

  const { data: creditCardDetails, loading } = useCache(
    getCreditCardDetailsById,
    { id: creditCardId },
    { revalidateOnFocus: false },
  );

  const currentParticipant: CreditCardBorrower | undefined = useMemo(() => {
    return creditCardDetails?.[applicationParticipant.role];
  }, [creditCardDetails, applicationParticipant.role]);

  const workflow = currentParticipant?.workflow;
  const onboardingDetails = currentParticipant?.onboardingDetails;
  const documentation = currentParticipant?.documentation;

  useSetPageLoadingWhenRequesting('CREDIT_CARD', [loading]);

  return {
    creditCardDetails,
    documentation,
    workflow,
    onboardingDetails,
    loading,
  };
};
